import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Path, Rect, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import { getPaymentBadgeColors } from './paymentBadgeColors';

export interface CardBadgeIconProps extends SvgProps {
  width?: number;
  height?: number;
  selected?: boolean;
}

const CardBadgeIcon: React.FC<CardBadgeIconProps> = ({
  width = 38,
  height = 24,
  selected = false,
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  const { background, foreground } = getPaymentBadgeColors(selected);

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 38 24"
      fill="none"
      {...props}
    >
      <Rect height="24" rx="3" width="38" fill={colors[background]} />
      <Path
        d="M24.4694 6.59998H13.5306C12.5119 6.59998 12 7.25759 12 8.56015V9.14821H26V8.56015C26 7.25759 25.493 6.59998 24.4694 6.59998ZM13.9936 15.4397C13.706 15.4397 13.5159 15.1868 13.5159 14.8327V13.6629C13.5159 13.3025 13.706 13.0559 13.9936 13.0559H15.1878C15.4753 13.0559 15.6654 13.3025 15.6654 13.6629V14.8327C15.6654 15.1868 15.4753 15.4397 15.1878 15.4397H13.9936ZM13.5306 17.3999H24.4694C25.493 17.3999 26 16.7486 26 15.446V10.5836H12V15.446C12 16.7486 12.5118 17.3999 13.5306 17.3999Z"
        fill={colors[foreground]}
      />
    </Svg>
  );
};

CardBadgeIcon.displayName = 'CardBadgeIcon';
export { CardBadgeIcon };
